import { render, staticRenderFns } from "./CiDeleteModal.vue?vue&type=template&id=03bc2851&"
import script from "./CiDeleteModal.vue?vue&type=script&lang=js&"
export * from "./CiDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./CiDeleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports